import { Text, View } from "@react-pdf/renderer";

function Column({ columnName, items, smallColumn }) {
  return (
    <View>
      <View
        style={{
          width: "auto",
          backgroundColor: "#000",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <Text
          style={{
            fontWeight: 600,
            fontSize: smallColumn ? 7 : 9,
            margin: 10,
            color: "#fff",
          }}
        >
          {columnName}
        </Text>
      </View>
      {items.map((value, index) => {
        return (
          <View
            key={index}
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              backgroundColor: "#fff",
            }}
          >
            <Text
              style={{
                fontSize: smallColumn ? 7 : 9,
                margin: 8,
                color: "#000",
                height: "auto",
              }}
            >
              {value}
            </Text>
          </View>
        );
      })}
    </View>
  );
}
export default Column;
